import React from 'react';

import { Paragraph } from '../Typography';

export default () => (
  <Paragraph>Sorry, adding this topic is not currently supported.</Paragraph>
);
